import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import get from 'lodash/get'

/**
 * Determines whether the current channel ID and webcast ID has fetched data successfully
 * @param state The Redux state
 */

const getWebcastDataStatus = (state: State): boolean => {

  const collectionId = `${state.config.channelId}${state.config.webcastId}`
  return get(state.webcast, `collection.${collectionId}.status.hasData`, false)

}

export default createSelector(
  [getWebcastDataStatus],
  (hasWebcastData) => {

    return hasWebcastData

  })
